export const FIELDS = 'items(id,name)';
export const MAX_RESULTS = 30;
